/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const payloadClickStreamPlaceOrder = (recips, orderId, brand) => {
    const order = { orderNumber: orderId };
    const orderItems = [];

    recips.map((recipient) => {
        recipient.cartItems.map((cartItem) => {
            if (cartItem.cartItemId && cartItem.product) {
                orderItems.push({
                    orderItemsId: cartItem.cartItemId,
                    product: {
                        price: cartItem.price,
                        name: cartItem.product.parentProductName,
                        baseCode: cartItem.product.parentCode,
                    },
                });
            }
        });
    });

    if (orderItems.length > 0) {
        order.orderItems = orderItems;
    }
    const payload = {
        eventType: 'clickstream.order-complete',
        metaData: {
            brand: brand.domain,
            order,
        },
    };

    return payload;
};

export default {};
